import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import serviceWorkerConfig from "./serviceWorkerConfig";
import { initSentry } from "./Utils/Sentry";

initSentry();

// NB: Apollo seems to have some issues with strict mode, have to disable it for duplicate resolution to work as expected while debugging
ReactDOM.render(<App />, document.getElementById("root"));

// ReactDOM.render(
//     <React.StrictMode>
//         <App />
//     </React.StrictMode>,
//     document.getElementById("root")
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA

// it is hard to get the app to reload when it's cached, especially on an ipad
// https://redfin.engineering/how-to-fix-the-refresh-button-when-using-service-workers-a8e27af6df68
// https://stackoverflow.com/questions/52904430/how-to-implement-skipwaiting-with-create-react-app
serviceWorkerRegistration.register(serviceWorkerConfig);
// serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
// reportWebVitals(console.log);
